module.exports = __webpack_public_path__ + "img/i-lead-logo.8c9ebf7a.png";